import { resolveBrand } from "@/shared/constants/brand";
import { getPublicPath } from "@/shared/utils/getPublicPath";

// Знак кабинета по бренду сборки (VITE_BRAND): у adult-инстанса он свой,
// без переменной остаётся знак ottkit.
const brand = resolveBrand(import.meta.env.VITE_BRAND);

export const config = {
  logoUrl: getPublicPath(brand.miniLogo),
};
